/**
 * Shared Pro-access helpers for subscription types.
 * PRO10-90 / Pro-10 unlock the same product features as Pro.
 */

const SUBSCRIPTION_TYPE_LABELS = {
  trial: "Trial",
  Monthly: "Monthly",
  sub_01m: "Monthly",
  Annual: "Annual",
  sub_12m: "Annual",
  sub_100_12m: "Pro",
  Pro: "Pro",
  "Pro-10": "Pro-10",
  PRO10: "PRO10",
  "PRO10-90": "PRO10-90",
  Annual10: "Annual10",
  GuestAsk: "Guest Ask",
};

/** Human-readable plan name for profile and admin lists. */
export function getSubscriptionTypeLabel(subscriptionType) {
  if (!subscriptionType) {
    return "Free";
  }
  return SUBSCRIPTION_TYPE_LABELS[subscriptionType] || String(subscriptionType);
}

export function normalizeSubscriptionTypeKey(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[_\s-]+/g, "");
}

export function isPro10SubscriptionType(subscriptionType) {
  return normalizeSubscriptionTypeKey(subscriptionType).includes("pro10");
}

/** True for full Pro and special Pro-10 / PRO10-90 offers. */
export function isProSubscriptionType(subscriptionType) {
  if (!subscriptionType) {
    return false;
  }
  if (
    subscriptionType === "Pro" ||
    subscriptionType === "Pro-10" ||
    subscriptionType === "PRO10" ||
    subscriptionType === "PRO10-90" ||
    subscriptionType === "sub_100_12m"
  ) {
    return true;
  }
  return isPro10SubscriptionType(subscriptionType);
}

export const PRO_STRIPE_PRICE_IDS = [
  "price_1SXkSi03NFhO4KkKPfiFvjxt",
  "price_1SXkkn03NFhO4KkKjG1MOKZE",
  "price_1U1Qqv03NFhO4KkKVgw52JHe",
];

const {
  PLAN_CATALOG,
  getActiveGrantPlanKey,
  getEffectivePropertyLimit,
  hasFeature,
} = require("./entitlements.js");

export { getEffectivePropertyLimit, getActiveGrantPlanKey };

export function orgHasActiveProGrant(organization, nowMs) {
  const key = getActiveGrantPlanKey(organization, nowMs);
  return !!(key && PLAN_CATALOG[key] && PLAN_CATALOG[key].family === "pro");
}

export function orgHasActiveGuestAskGrant(organization, nowMs) {
  return getActiveGrantPlanKey(organization, nowMs) === "GuestAsk";
}

export function orgHasProBrandingAccess(organization, nowMs) {
  return hasFeature(organization, "whiteLabel", { now: nowMs });
}
